import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Download, Target, Activity } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-6 h-6" data-id="element-67" />,
    title: 'Descarga el Manual',
    desc: 'Accedes instantáneamente al código que tu Ser Superior pactó entregarte hoy.'
  }, {
    icon: <Target className="w-6 h-6" data-id="element-68" />,
    title: 'Identifica tus Hitos',
    desc: 'Reconoces tus problemas actuales como las cartas que elegiste para tu equilibrio.'
  }, {
    icon: <Activity className="w-6 h-6" data-id="element-69" />,
    title: 'Opera la Lattice',
    desc: 'Aplicas el protocolo O→A→S y ves cómo tu realidad física comienza a reconfigurarse ante tus ojos.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <FadeIn data-id="element-72">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16 text-white" data-id="element-73">
            Cómo <span className="text-gold-400" data-id="element-74">funciona</span>
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-75">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} direction="up" data-id="element-76">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 p-6 sm:p-8 rounded-xl bg-navy-900/50 border border-white/5 relative overflow-hidden group" data-id="element-77">
                {/* Number background */}
                <div className="absolute -right-4 -top-8 text-[120px] font-bold text-white/[0.02] font-serif pointer-events-none group-hover:text-gold-500/[0.02] transition-colors" data-id="element-78">
                  {index + 1}
                </div>

                <div className="w-14 h-14 rounded-full bg-gold-500/10 border border-gold-500/30 flex items-center justify-center text-gold-400 flex-shrink-0" data-id="element-79">
                  {step.icon}
                </div>

                <div className="relative z-10" data-id="element-80">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-81">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-lg" data-id="element-82">{step.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}